import GetStarted from '@/pages/GetStarted'

export default {
  path: '/getstarted/',
  name: 'GetStarted',
  component: GetStarted
}



// WEBPACK FOOTER //
// ./src/router/getstarted.js